'use client';

import { FC, PropsWithChildren } from 'react';

import { ArkProvider } from '@sola/ark-core/contexts/ark.js';
import { AuthProvider } from '@sola/auth-sdk/components/auth-provider.js';
import { Sites, getPublicConfig } from '@sola/config/lib/getters.js';
import { SiteConfigResponseDto } from '@sola/schema/lib/contentful.js';

import { SiteConfigContext } from './context';

export const SkippyProviders: FC<
  PropsWithChildren<{
    siteConfig?: SiteConfigResponseDto;
    locale?: string;
  }>
> = ({ children, siteConfig, locale }) => {
  const publicConfig = getPublicConfig();
  const includeAuthProvider =
    publicConfig.NEXT_PUBLIC_SITE_ID !== Sites.enum.compex;

  const content = (
    <ArkProvider locale={locale}>
      <SiteConfigContext.Provider value={siteConfig}>
        {children}
      </SiteConfigContext.Provider>
    </ArkProvider>
  );

  return includeAuthProvider ? <AuthProvider>{content}</AuthProvider> : content;
};
